export default __webpack_public_path__ + "static/testimonial-user-5-98de00201a219328a695ed72255c520d.jpg";